import { render, staticRenderFns } from "./payinfo.vue?vue&type=template&id=08a28fd4&"
import script from "./payinfo.vue?vue&type=script&lang=js&"
export * from "./payinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports